// PK modülü PDF hücre renkleri — ekrandaki rozet renkleriyle aynı (exportTableToPDF cellStyler için)
const W = [255, 255, 255];
const K = [0, 0, 0];
const c = (fill, text = W) => ({ fillColor: fill, textColor: text, halign: 'center' });

export const ETIKET_PDF = {
  'Kırmızı': c([239, 68, 68]), 'Sarı': c([234, 179, 8], K), 'Mavi': c([59, 130, 246]), 'Yeşil': c([34, 197, 94]),
};
export const DURUM_PDF = {
  'Güvensiz': c([185, 28, 28]), 'Kusurlu': c([161, 98, 7]), 'Hafif Kusurlu': c([202, 138, 4], K), 'Kusursuz': c([21, 128, 61]),
};
export const SONUC_PDF = {
  'Uygun': c([21, 128, 61]), 'Şartlı Uygun': c([202, 138, 4], K), 'Uygun Değil': c([185, 28, 28]),
};
export const EVET_HAYIR_PDF = {
  'Evet': { textColor: [21, 128, 61], halign: 'center' }, 'Hayır': { textColor: [220, 38, 38], halign: 'center' },
};
export const ONCELIK_PDF = {
  'Kritik': c([220, 38, 38]), 'Yüksek': c([234, 88, 12]), 'Normal': c([37, 99, 235]), 'Düşük': c([75, 85, 99]),
};
export const ARIZA_DURUM_PDF = {
  'Açık': c([185, 28, 28]), 'Atandı': c([202, 138, 4], K), 'Müdahale': c([37, 99, 235]), 'Çözüldü': c([21, 128, 61]), 'Kapandı': c([75, 85, 99]),
};

// 'SLA İhlal (…)' / 'SLA AŞILDI (…)' → kırmızı; 'SLA OK' → yeşil; 'x.xh kaldı' → turuncu (≤3h) / gri
export const slaStyle = (raw) => {
  const s = String(raw || '');
  if (/İhlal|AŞILDI/i.test(s)) return { textColor: [220, 38, 38] };
  if (/SLA OK/.test(s)) return { textColor: [21, 128, 61] };
  const m = s.match(/^([\d.,]+)h kaldı/);
  if (m) return { textColor: parseFloat(m[1].replace(',', '.')) <= 3 ? [234, 88, 12] : [107, 114, 128] };
  return null;
};

export const kirmiziMetin = (raw) => (raw && raw !== '-' ? { textColor: [220, 38, 38] } : null);
